import { bootstrap as bootstrapGtag } from 'vue-gtag';
import { acceptedCategory } from 'vanilla-cookieconsent';

export function getCookieConsentConfig() {
    return {
        categories: {
            necessary: {
                enabled: true,
                readOnly: true,
            },
            analytics: {
                autoClear: {
                    cookies: [
                        { name: /^_ga/ },
                        { name: '_gid' },
                    ],
                },
            },
        },

        onConsent: () => {
            if (acceptedCategory('analytics')) {
                bootstrapGtag();
            }
        },

        onChange: ({ changedCategories }) => {
            if (changedCategories.includes('analytics')) {
                if (acceptedCategory('analytics')) {
                    bootstrapGtag();
                } else {
                    window.location.reload();
                }
            }
        },

        guiOptions: {
            consentModal: {
                layout: 'box inline',
                position: 'bottom left',
            },
        },

        language: {
            default: 'en',
            translations: {
                en: {
                    consentModal: {
                        title: 'Cookie Preferences',
                        description: 'We use cookies to analyze site traffic and improve your experience. Necessary cookies are always active. You can choose whether to allow analytics cookies.',
                        acceptAllBtn: 'Accept All',
                        acceptNecessaryBtn: 'Reject All',
                        showPreferencesBtn: 'Manage Preferences',
                    },
                    preferencesModal: {
                        title: 'Cookie Preferences',
                        acceptAllBtn: 'Accept All',
                        acceptNecessaryBtn: 'Reject All',
                        savePreferencesBtn: 'Save Preferences',
                        sections: [
                            {
                                title: 'Necessary Cookies',
                                description: 'These cookies are required for the site to function properly, including session management, shopping cart, and spam protection (reCAPTCHA).',
                                linkedCategory: 'necessary',
                            },
                            {
                                title: 'Analytics Cookies',
                                description: 'These cookies help us understand how visitors use our site through Google Analytics, so we can improve our content and your experience.',
                                linkedCategory: 'analytics',
                            },
                        ],
                    },
                },
            },
        },
    };
}
